const LOGO_URL = 'https://storage.readdy-site.link/project_files/d8bcc27c-0b18-4a10-81b7-54a88326e269/eef687c5-6cb0-41fa-90b8-160538453ebf_LOGO-1---Dbora-Martins-Photoroom.png?v=89cba24b9a9a6a7ad6cf718733ec20fb';

const QUICK_LINKS = [
  { label: 'Sobre o Escritório', href: '#sobre' },
  { label: 'Áreas de Atuação', href: '#areas' },
  { label: 'Como Atuamos', href: '#como-atuamos' },
  { label: 'Contato', href: '#contato' },
];

const AREAS = [
  'Direito Trabalhista',
  'Direito do Consumidor',
  'Direito de Família',
  'Direito Previdenciário',
];

export default function Footer() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-marrom-escuro text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src={LOGO_URL}
                  alt="Carvalho e França Advogadas"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <p className="font-serif text-dourado-principal text-base font-semibold">Carvalho e França</p>
                <p className="font-sans text-white/50 text-xs tracking-widest uppercase">Advogadas</p>
              </div>
            </div>
            <p className="font-sans text-white/55 text-sm leading-relaxed mb-6">
              Advocacia especializada, humanizada e comprometida com os direitos dos
              cidadãos de Duque de Caxias e região.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://instagram.com/carvalhofranca.adv"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full hover:border-dourado-principal hover:text-dourado-principal transition-all duration-300 cursor-pointer text-white/60"
              >
                <i className="ri-instagram-line text-lg" />
              </a>
              <a
                href="https://wa.me/5521974393072"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full hover:border-dourado-principal hover:text-dourado-principal transition-all duration-300 cursor-pointer text-white/60"
              >
                <i className="ri-whatsapp-line text-lg" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-dourado-principal text-lg font-semibold mb-5">
              <a href="#inicio" className="hover:text-dourado-claro transition-colors">Links Rápidos</a>
            </h4>
            <ul className="space-y-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => handleScroll(link.href)}
                    className="font-sans text-white/55 text-sm hover:text-dourado-claro transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-dourado-principal/60 text-sm" />
                    </div>
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h4 className="font-serif text-dourado-principal text-lg font-semibold mb-5">
              <a href="#areas" className="hover:text-dourado-claro transition-colors">Áreas de Atuação</a>
            </h4>
            <ul className="space-y-2.5">
              {AREAS.map((area) => (
                <li key={area}>
                  <button
                    onClick={() => handleScroll('#areas')}
                    className="font-sans text-white/55 text-sm hover:text-dourado-claro transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-scales-line text-dourado-principal/60 text-sm" />
                    </div>
                    {area}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-dourado-principal text-lg font-semibold mb-5">
              <a href="#contato" className="hover:text-dourado-claro transition-colors">Contato</a>
            </h4>
            <div className="space-y-4">
              <div className="flex gap-3 items-center">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-whatsapp-line text-dourado-principal text-base" />
                </div>
                <a
                  href="https://wa.me/5521974393072"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="font-sans text-white/55 text-sm hover:text-dourado-claro transition-colors cursor-pointer"
                >
                  +55 (21) 97439-3072
                </a>
              </div>

              <div className="flex gap-3 items-center">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-instagram-line text-dourado-principal text-base" />
                </div>
                <a
                  href="https://instagram.com/carvalhofranca.adv"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="font-sans text-white/55 text-sm hover:text-dourado-claro transition-colors cursor-pointer"
                >
                  @carvalhofranca.adv
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-sans text-white/35 text-xs text-center sm:text-left">
            © 2026 Carvalho e França Advogadas. Todos os direitos reservados.
          </p>
          <p className="font-sans text-white/35 text-xs text-center sm:text-right">
            OAB/RJ – Atuação ética conforme diretrizes da OAB |{' '}
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="nofollow noreferrer"
              className="text-dourado-principal/60 hover:text-dourado-principal transition-colors cursor-pointer"
            >
              Desenvolvido por Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
